import { Outlet } from 'react-router-dom';

/** Layout minimalista para exibição em TV (sem sidebar/header). */
export default function TvLayout() {
    return (
        <main className="min-h-screen bg-[#f3f4f6] text-gray-900">
            <Outlet />
        </main>
    );
}
